/**
 * The archive of Today in chess: every day's worthy games, newest first, a week
 * at a time from `/api/news/archive` (`worker/news.js`). The cards are the front
 * page's, from `../today.js`, so a game looks the same wherever it is met.
 */

import { card, countOpens, dayWord } from '../today.js';

const API = '/api/news/archive';

const $ = (id) => document.getElementById(id);
const days = $('nw-days');
const more = $('nw-more');
const note = $('nw-note');

/** "Tuesday 23 September", with the year once it is not this one. */
export function longDay(date, now = new Date()) {
  const [y, m, d] = String(date).split('-').map(Number);
  const then = new Date(y, m - 1, d);
  return then.toLocaleDateString('en-GB', {
    weekday: 'long', day: 'numeric', month: 'long', ...(y !== now.getFullYear() ? { year: 'numeric' } : {}),
  });
}

const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({
  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
}[c]));

function daySection({ day, items }) {
  const near = dayWord(day);
  const label = /^(Today|Yesterday)$/.test(near) ? `${near} · ${longDay(day)}` : longDay(day);
  return `<section class="nw-day" aria-label="${esc(label)}">
    <h2>${esc(label)} <span class="nw-n">${items.length} ${items.length === 1 ? 'game' : 'games'}</span></h2>
    <div class="w-news-grid">${items.map((item) => card(item, false, { day: false })).join('')}</div>
  </section>`;
}

let next = '';
let first = true;

async function load() {
  more.disabled = true;
  more.textContent = 'Loading…';
  note.hidden = true;
  let page;
  try {
    const res = await fetch(next ? `${API}?before=${encodeURIComponent(next)}` : API);
    if (!res.ok) throw new Error(String(res.status));
    page = await res.json();
  } catch {
    note.textContent = navigator.onLine === false
      ? 'You are offline. The games will be here when you are back.'
      : 'The games did not load. Try again in a moment.';
    note.hidden = false;
    more.hidden = false;
    more.disabled = false;
    more.textContent = 'Try again';
    return;
  }
  days.insertAdjacentHTML('beforeend', (page.days || []).map(daySection).join(''));
  if (first && !(page.days || []).length) {
    note.textContent = 'Nothing yet. The first games arrive after the next round of a big event.';
    note.hidden = false;
  }
  first = false;
  next = page.next || '';
  more.hidden = !next;
  more.disabled = false;
  more.textContent = 'Show the week before';
}

more.addEventListener('click', load);
countOpens(days);
load();
